// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2KGDW","content":"RecentSearches_content__1tHAi"};